import type { TriggerForPersonFrequencyEnum } from '@DigitaleDoerfer/digitale-doerfer-api';

import { useGrapevineAdminStatisticsDebugApi } from '@/features/api/hooks/grapevine-admin-statistics-debug/useGrapevineAdminStatisticsDebugApi';
import { useGetPerson } from '@/features/api/hooks/participant/useGetPerson';
import { useApiMutation } from '@/features/api/hooks/useApiMutation';

type TriggerVariables = {
  frequency: TriggerForPersonFrequencyEnum;
};

export const useTriggerStatisticsEmailDebug = () => {
  const api = useGrapevineAdminStatisticsDebugApi();
  const { data: person } = useGetPerson();

  return useApiMutation({
    mutationFn: ({ frequency }: TriggerVariables) => {
      if (!person?.id) {
        throw new Error(
          'Cannot trigger statistics email: current person id is not available.'
        );
      }
      return api.triggerForPerson({ personId: person.id, frequency });
    }
  });
};
